

import * as React from "react"
import { Link, Routes, Route } from "react-router-dom"
import { Haiti } from "./haiti"
//import "../styles/site-main.css"
import { Home } from "./home"
import { Contact } from "./contactinfo"
import { Stripes } from "./stripes"
import { BC } from "./bc"

export function SiteHome() {

    var isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
    var style = isMobile ? { paddingBottom: '300px' } : {}
    return <div>
        <div >
            <header style={{fontFamily: 'Dancing Script'}} className="p-4 text-white mb-5 bg-gradient-to-r from-blue-600 to-blue-400 shadow-lg shadow-blue-400 sticky top-0 z-50">
                <div className="flex w-full">
                <div className=" w-1/2 ml-8 mt-0 text-5xl lg:text-7xl leading-tight text-primary">
                    Diapers For Haiti
                </div>

                <div className="w-1/2 flex justify-between items-center text-2xl lg:text-4xl p-2">
                    <Link className="flex-grow text-center" to="/">Home</Link>
                    <Link className="flex-grow text-center" to="/howtosew">How to Make</Link>
                    <Link className="flex-grow text-center" to="/contact">Contact</Link>
                </div>
                </div>
            </header>
            <Routes>
                <Route path="/*" element={<Haiti />} />
                <Route path="/howtosew/*" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/bc" element={<BC />} />
            </Routes>
        </div>
        <Stripes />
    </div>
}